import { render, staticRenderFns } from "./PositionedPages.vue?vue&type=template&id=586c1de3&scoped=true&"
import script from "./PositionedPages.vue?vue&type=script&lang=js&"
export * from "./PositionedPages.vue?vue&type=script&lang=js&"
import style0 from "./PositionedPages.vue?vue&type=style&index=0&id=586c1de3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c1de3",
  null
  
)

/* custom blocks */
import block0 from "./PositionedPages.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports